import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { Util } from 'src/app/utils/utils';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { GlobalVariable } from 'src/app/global';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { ProductosService } from 'src/app/snapquick/services/productos/productos.service';
import {Md5} from 'ts-md5/dist/md5';
import { RegistroJugadorComponent } from '../registro-jugador/registro-jugador.component';
import { GeminiApiService } from '../../../base/services/gemini-api/gemini-api.service';
import { Observable, Subject } from 'rxjs';
import { WebcamImage } from 'ngx-webcam';

declare const resaltarPestañaMenu:any;

@Component({
  selector: 'app-caja-mesa',
  templateUrl: './caja-mesa.component.html',
  styleUrls: ['./caja-mesa.component.css']
})
export class CajaMesaComponent extends BaseComponent implements OnInit {

  cajas:any[]=[];
  nuevo_caja_mesa:any;
  roles_partidos:[]=[];
  cierres_caja:any;
  cierre_caja:any;
  campeonatos:any;
  productos:any;
  rol_partido:any;

  modal_registro_caja_mesa:NgbModalRef;
  @ViewChild('modal_registro_caja_mesa')
  private modal_registro_caja_mesa_ref: TemplateRef<any>;

  modalJugador:NgbModalRef;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  webcamImage: WebcamImage | null = null;

  usando_camara:boolean=false;

  @ViewChild('subir-foto-planilla') fileInput!: ElementRef<HTMLInputElement>;
  
  constructor(private router: Router,
      public generalService:GeneralService,
      public persistenciaService:PersistenciaService,
      public usuarioService:UsuarioService,
      public modalService: NgbModal,
      private toastr: ToastrService,
      private productosService:ProductosService,
      public campeonatosService:CampeonatosService,
    public rolesPartidosService:RolesPartidosService,
  private geminiService: GeminiApiService) { 
        super(persistenciaService,modalService,generalService,usuarioService);
      }

  async ngOnInit(): Promise<void> {
    this.init();
    this.buscarAplicacion(this.router.url.substring(1));
    this.configuracion_pagina={};
    let es_usuario_administrador=Util.esUsuarioAdministrador(this.usuario);
    this.filter={
      id_empresa:this.usuario.id_empresa,
      campeonato:GlobalVariable.Dictionary.SELECCION_TODOS,
      campeonatos:[GlobalVariable.Dictionary.SELECCION_TODOS],
      usuarios:[{nombre_usuario:"TODOS",id:0}],
      usuario: {nombre_usuario:"TODOS",id:0},
    }

    if(this.usuario.empresa.usar_control_por_usuarios){
        if(es_usuario_administrador){	
          this.obtenerUsuarios();
        }else{
          this.filter.usuarios=[this.usuario]
          this.filter.usuario=this.usuario;          
        }
    }else{
        this.filter.usuarios=[this.usuario]
        this.filter.usuario=this.usuario;
    }

    this.obtenerCampeonatos();
    this.obtenerProductosEmpresa();
  
      this.column = "updatedAt";
      this.direction = "desc";
      this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
        resaltarPestañaMenu(this.router.url.substring(1)+"1");
  }

  async obtenerUsuarios(){
    let usuarios_empresa:any=await this.usuarioService.obtenerUsuariosEmpresa(this.usuario.id_empresa).toPromise();
    this.filter.usuarios=this.filter.usuarios.concat(usuarios_empresa);
  }

  async obtenerCampeonatos(){
    this.filter.campeonatos=[GlobalVariable.Dictionary.SELECCION_TODOS];
    let campeonatos=await this.campeonatosService.obtenerCampeonatosEmpresa(this.usuario.id_empresa).toPromise();
    this.filter.campeonatos=this.filter.campeonatos.concat(campeonatos);
  }

  async obtenerProductosEmpresa(){
    this.productos=await this.productosService.obtenerProductosEmpresa(this.usuario.id_empresa).toPromise();
  }

  getItems(){
		this.blockUI.start('Recuperando... espere por favor!');
		this.rolesPartidosService.obtenerListaRolesPartidos(this).subscribe((dato:any) => {
			this.setPages(dato.paginas);
			this.roles_partidos=dato.roles_partidos;
			this.blockUI.stop();
		});
	}

  async abrirCierreCaja(rol_partido){
    if(this.filter.usuario.persona){
      this.rol_partido=rol_partido;
      this.blockUI.start();
      let rol_partido_datos:any=await this.rolesPartidosService.obtenerRolPartidoCierres(rol_partido.id).toPromise();
      this.blockUI.stop();
      rol_partido.cierres_caja=rol_partido_datos.cierres_caja;
      this.modificarRolPartido(rol_partido);
    }else{
      this.toastr.error("Debe seleccionar un usuario!");
    }
  }

  async modificarRolPartido(rol_partido){
    if(rol_partido.cierres_caja && rol_partido.cierres_caja.length>0){
      let cierre=rol_partido.cierres_caja.filter(c => c.mesa.id==this.filter.usuario.persona.arbitro.id);
      this.cierres_caja=rol_partido.cierres_caja.filter(c => c.mesa.id!=this.filter.usuario.persona.arbitro.id);
      if(cierre.length>0){
        this.cierre_caja=cierre[0];
        this.abrirRegistroCajaMesa();
      }else{
        await this.crearNuevoCierre(rol_partido);
      }
    }else{
      this.cierres_caja=[];
      await this.crearNuevoCierre(rol_partido);
    }
  }

  async crearNuevoCierre(rol_partido){
      this.blockUI.start();
      let mesa=this.filter.usuario.persona.arbitro;
      mesa.persona=JSON.stringify(this.filter.usuario.persona);
      mesa.persona=JSON.parse(mesa.persona);
      this.cierre_caja={
        mesa:mesa,
        partidos:[],
        pago_arbitro:0,
        pago_mesa:0,
        pago_otros:0,
        total_egresos:0,
        saldo_faltante:0,
        saldo_sobrante:0,
        importe_derecho_cancha:0
      }
      for(let i=0;i<rol_partido.partidos.length;i++){
        let partido:any=await this.rolesPartidosService.obtenerPartido(rol_partido.partidos[i].id).toPromise();
        partido.w_o_equipo_1={es_wo:false};
        partido.w_o_equipo_2={es_wo:false};
        this.cierre_caja.partidos.push(partido);
      }
      
      this.blockUI.stop();    
      for(let i=0;i<this.cierre_caja.partidos.length;i++){
        this.cierre_caja.partidos[i].equipo_1.detalles_ventas_pendientes=await this.rolesPartidosService.obtenerDetallesVentaPendientes(this.cierre_caja.partidos[i].equipo_1.cliente.id).toPromise();
        this.cierre_caja.partidos[i].equipo_2.detalles_ventas_pendientes=await this.rolesPartidosService.obtenerDetallesVentaPendientes(this.cierre_caja.partidos[i].equipo_2.cliente.id).toPromise();
        this.cierre_caja.importe_derecho_cancha=rol_partido.campeonato.derecho_cancha.precio_unitario+(this.cierre_caja.partidos[i].escenario.importe_partido/2);
        this.cierre_caja.partidos[i].equipo_1.detalle_pago=[{
                  id:"a"+this.cierre_caja.partidos[i].id+""+this.cierre_caja.partidos[i].equipo_1.id,
                  producto:rol_partido.campeonato.derecho_cancha,
                  precio_unitario:this.cierre_caja.importe_derecho_cancha,
                  importe:this.cierre_caja.importe_derecho_cancha,
                  total:this.cierre_caja.importe_derecho_cancha,
                  qr:0,
                  es_servicio:false,
                  es_combo:false,
                  es_pendiente:false,
                  item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
                  editar_precio:true,
                  cantidad:1,descuento:0,tipo_descuento:false
                }];
        this.cierre_caja.partidos[i].equipo_2.detalle_pago=[{
                  id:"a"+this.cierre_caja.partidos[i].id+""+this.cierre_caja.partidos[i].equipo_2.id,
                  producto:rol_partido.campeonato.derecho_cancha,
                  precio_unitario:this.cierre_caja.importe_derecho_cancha,
                  importe:this.cierre_caja.importe_derecho_cancha,
                  total:this.cierre_caja.importe_derecho_cancha,
                  qr:0,
                  es_servicio:false,
                  es_combo:false,
                  es_pendiente:false,
                  item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
                  editar_precio:true,
                  cantidad:1,descuento:0,tipo_descuento:false
                }];
      }
      this.sumarIngresos();
      this.abrirRegistroCajaMesa();
  }

  abrirRegistroCajaMesa(){
    this.modal_registro_caja_mesa=this.modalService.open(this.modal_registro_caja_mesa_ref, {windowClass:'rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
    this.modal_registro_caja_mesa.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  agregarPendiente(equipo,detalle_venta){
    if(equipo.detalle_pago.filter(p => p.id==("p"+equipo.id+""+detalle_venta.id)).length>0){
      this.toastr.error("¡El pendiente ya esta incluido!");
    }else{
      let fecha_pendiente=new Date(detalle_venta.venta.fecha);
      equipo.detalle_pago.push({
        id:"p"+equipo.id+""+detalle_venta.id,
        id_venta:detalle_venta.venta.id,
        producto:detalle_venta.producto,
        precio_unitario:detalle_venta.venta.saldo,
        importe:detalle_venta.venta.saldo,
        total:detalle_venta.venta.saldo,
        qr:0,
        es_servicio:false,
        es_combo:false,
        es_pendiente:true,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true,
        cantidad:1,descuento:0,tipo_descuento:false,
        descripcion:detalle_venta.descripcion,
        detalle_venta:detalle_venta,
        fecha:fecha_pendiente.getDate()+"/"+(fecha_pendiente.getMonth()+1)+"/"+fecha_pendiente.getFullYear()
      });
      this.sumarIngresos();
    }
  }

  async agregarTarjetaPago(partido,equipo,jugador,tarjeta){
    let tarjeta_producto=this.productos.filter(p => p.nombre.includes(tarjeta));
    tarjeta_producto=tarjeta_producto.length>0?tarjeta_producto[0]:null;
    if(equipo.detalle_pago.filter(p => p.id.includes(tarjeta_producto.id+""+equipo.id+""+jugador.id)).length>0){
      this.toastr.error("¡La tarjeta ya esta incluida para el jugador!");
    }else{
      equipo.detalle_pago.push({
        id:tarjeta_producto.id+""+equipo.id+""+jugador.id,
        jugador:jugador,
        producto:tarjeta_producto,
        descripcion:jugador.persona.nombre_completo,
        precio_unitario:tarjeta_producto.precio_unitario,
        importe:tarjeta_producto.precio_unitario,
        total:tarjeta_producto.precio_unitario,
        qr:0,
        es_servicio:false,
        es_combo:false,
        es_pendiente:false,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true,
        cantidad:1,descuento:0,tipo_descuento:false
      });
      this.sumarIngresos();

      if(tarjeta_producto.nombre.includes("AMARILLA")){
        if(partido.equipo_1.id==equipo.id){
          partido.lista_amarillas_equipo_1=partido.lista_amarillas_equipo_1?partido.lista_amarillas_equipo_1:[];
          let jugador_e=partido.lista_amarillas_equipo_1.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_amarillas_equipo_1.push(jugador);
          }
        }else{
          partido.lista_amarillas_equipo_2=partido.lista_amarillas_equipo_2?partido.lista_amarillas_equipo_2:[];
          let jugador_e=partido.lista_amarillas_equipo_2.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_amarillas_equipo_2.push(jugador);
          }
        }
      }else if(tarjeta_producto.nombre.includes("ROJA")){
        if(partido.equipo_1.id==equipo.id){
          partido.lista_rojas_equipo_1=partido.lista_rojas_equipo_1?partido.lista_rojas_equipo_1:[];
          let jugador_e=partido.lista_rojas_equipo_1.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_rojas_equipo_1.push(jugador);
          }
        }else{
          partido.lista_rojas_equipo_2=partido.lista_rojas_equipo_2?partido.lista_rojas_equipo_2:[];
          let jugador_e=partido.lista_rojas_equipo_2.filter(j => j.id==jugador.id);
          if(jugador_e.length<=0){
            partido.lista_rojas_equipo_2.push(jugador);
          }
        }
      }
    }
  }

  async agregarProductoAdicional(equipo,producto_texto){
    let producto=this.productos.filter(p => p.nombre.toUpperCase().includes(producto_texto.toUpperCase()));
    producto=producto.length>0?producto[0]:null;
    if(equipo.detalle_pago.filter(p => p.id.includes(producto.id+""+equipo.id)).length>0){
      this.toastr.error("¡La servicio ya esta incluido!");
    }else{
      equipo.detalle_pago.push({
        id:producto.id+""+equipo.id,
        producto:producto,
        precio_unitario:producto.precio_unitario,
        importe:producto.precio_unitario,
        total:producto.precio_unitario,
        qr:0,
        es_servicio:false,
        es_combo:false,
        es_pendiente:false,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true,
        cantidad:1,descuento:0,tipo_descuento:false
      });
      this.sumarIngresos();
    }
  }

  sumarIngresos(){
    this.cierre_caja.total_ingresos_efectivo=0,this.cierre_caja.total_ingresos_qr=0;
    for(let i=0;i<this.cierre_caja.partidos.length;i++){
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
        this.cierre_caja.total_ingresos_efectivo=this.cierre_caja.total_ingresos_efectivo+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].importe;
        this.cierre_caja.total_ingresos_qr=this.cierre_caja.total_ingresos_qr+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].qr;
      }
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
        this.cierre_caja.total_ingresos_efectivo=this.cierre_caja.total_ingresos_efectivo+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].importe;
        this.cierre_caja.total_ingresos_qr=this.cierre_caja.total_ingresos_qr+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].qr;
      }
    }
    this.cierre_caja.saldo_caja=this.cierre_caja.total_ingresos_efectivo-this.cierre_caja.total_egresos+this.cierre_caja.saldo_sobrante-this.cierre_caja.saldo_faltante;
  }

  sumarEgresos(){
    this.cierre_caja.total_egresos=this.cierre_caja.pago_arbitro+this.cierre_caja.pago_mesa+this.cierre_caja.pago_otros;
    this.cierre_caja.saldo_caja=this.cierre_caja.total_ingresos_efectivo-this.cierre_caja.total_egresos+this.cierre_caja.saldo_sobrante-this.cierre_caja.saldo_faltante;
  }

  guardarRolPartidoCierre(){
    if(this.cierre_caja.procesado){
        this.toastr.warning("El cierre de caja ya fue procesado!");
    }else{
      if(this.validarCierreCajaMesa()){
        this.blockUI.start();
        const md5 = new Md5();
        this.cierre_caja._id=this.cierre_caja._id?this.cierre_caja._id:md5.appendStr(new Date().toUTCString()).end();
        let rol_partido={
          id:this.rol_partido.id,
          cierres_caja:this.cierres_caja
        }
        
        rol_partido.cierres_caja.push(this.cierre_caja);
        this.rolesPartidosService.actualizarCierreCajaRolPartido(rol_partido).subscribe((res:any)=>{
          this.blockUI.stop();
          this.modal_registro_caja_mesa.close();
          this.toastr.success(res.mensaje);
          this.getItems();
        });
      }
    }
  }

  validarCierreCajaMesa(){
    let res=true;
    for(let i=0;i<this.cierre_caja.partidos.length;i++){
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].importe==undefined){
          this.toastr.error("Debe especificar el importe en todos los equipos!");
          res=false;
        }
        if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].qr==undefined){
          this.toastr.error("Debe especificar el qr en todos los equipos!");
          res=false;
        }
      }
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].importe==undefined){
          this.toastr.error("Debe especificar el importe en todos los equipos!");
          res=false;
        }
        if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].qr==undefined){
          this.toastr.error("Debe especificar el qr en todos los equipos!");
          res=false;
        }
      }

      if(this.rol_partido.campeonato.configuracion_pdf_rol_partido.caja_marcador){
        if(!this.cierre_caja.partidos[i].w_o_equipo_1.es_wo && !this.cierre_caja.partidos[i].w_o_equipo_2.es_wo){
          if(this.cierre_caja.partidos[i].marcador_equipo_1 === null){
            this.toastr.error(`Debe ingresar un marcador valido al equipo ${this.cierre_caja.partidos[i].equipo_1.nombre}!`);
            res=false;
          }
          if(this.cierre_caja.partidos[i].marcador_equipo_2 === null){
            this.toastr.error(`Debe ingresar un marcador valido al equipo ${this.cierre_caja.partidos[i].equipo_2.nombre}!`);
            res=false;
          }
          if(this.cierre_caja.partidos[i].marcador_equipo_1 < 0 || this.cierre_caja.partidos[i].marcador_equipo_2 < 0){
            this.toastr.error("No ingresar numeros negativos en los marcadores");
            res=false;
          }

          if(this.cierre_caja.partidos[i].marcador_equipo_1!=this.cierre_caja.partidos[i].equipo_1.total_marcador){
            this.toastr.error("Marcador del equipo: "+this.cierre_caja.partidos[i].equipo_1.nombre+" incorrecto!");
            res=false;
          }
          if(this.cierre_caja.partidos[i].marcador_equipo_2!=this.cierre_caja.partidos[i].equipo_2.total_marcador){
            this.toastr.error("Marcador del equipo: "+this.cierre_caja.partidos[i].equipo_2.nombre+" incorrecto!");
            res=false;
          }
        }
      }
    }
		if(this.cierre_caja.pago_arbitro==undefined){
			this.toastr.error("Debe especificar el pago al arbitro!");
			res=false;
		}
    if(this.cierre_caja.pago_mesa==undefined){
			this.toastr.error("Debe especificar el pago a mesa!");
			res=false;
		}
    if(this.cierre_caja.pago_otros==undefined){
			this.toastr.error("Debe especificar el pago a otros!");
			res=false;
		}
    if(this.cierre_caja.saldo_faltante==undefined){
			this.toastr.error("Debe especificar el saldo faltante!");
			res=false;
		}
    if(this.cierre_caja.saldo_sobrante==undefined){
			this.toastr.error("Debe especificar el saldo sobrante!");
			res=false;
		}
		return res;
  }

  eliminarServicio(partido,equipo,detalle){
    if(equipo.detalle_pago.indexOf(detalle)>0){
      equipo.detalle_pago.splice(equipo.detalle_pago.indexOf(detalle),1);

      if(!detalle.es_pendiente){
        if(detalle.producto.nombre.includes("AMARILLA")){
          if(partido.equipo_1.id==equipo.id){
            let indexJugador = partido.lista_amarillas_equipo_1.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_amarillas_equipo_1.splice(indexJugador, 1);
          }else{
            let indexJugador = partido.lista_amarillas_equipo_2.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_amarillas_equipo_2.splice(indexJugador, 1);
          }
        }else if(detalle.producto.nombre.includes("ROJA")){
          if(partido.equipo_1.id==equipo.id){
            let indexJugador = partido.lista_rojas_equipo_1.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_rojas_equipo_1.splice(indexJugador, 1);
          }else{
            let indexJugador = partido.lista_rojas_equipo_2.findIndex(jugadorLista => jugadorLista.id_persona === detalle.jugador.id_persona);
            partido.lista_rojas_equipo_2.splice(indexJugador, 1);
          }
        }
      }

    }
  }

  generarmensajeWhatsapp(){
    let fecha=new Date();
    let mensaje="📆 "+fecha.toLocaleDateString("es-ES", { weekday: 'long' }).toUpperCase()+", "+fecha.getDate()+" "+fecha.toLocaleString('es-ES', { month: 'long' }).toUpperCase()+" "+fecha.getFullYear()+"\n";
    mensaje=mensaje+"Código de Rol de Partido: "+this.rol_partido.codigo+"\n";

    for(let i=0;i<this.cierre_caja.partidos.length;i++){
      mensaje=mensaje+"\n ✓"+this.cierre_caja.partidos[i].equipo_1.nombre;
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("ARBITRAJE")){
          mensaje=mensaje+"\n    👨🏽‍⚖️ "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("AMARILLA")){
          mensaje=mensaje+"\n    🟨 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("ROJA")){
          mensaje=mensaje+"\n    🟥 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN BALON")){
          mensaje=mensaje+"\n    ⚽ "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN CINTILLO")){
          mensaje=mensaje+"\n    🎗️ "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre.toUpperCase().includes("PONCHILLOS")){
          mensaje=mensaje+"\n    🎽 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre;
        }else{
          mensaje=mensaje+"\n    💵 "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].producto.nombre+(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion?" "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].descripcion:"");
        }
        mensaje=mensaje+(this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].fecha?" - "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].fecha:"")+"\n";
        mensaje=mensaje+"      💵 Bs "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].importe;
        mensaje=mensaje+" | 🏁 Bs "+this.cierre_caja.partidos[i].equipo_1.detalle_pago[j].qr;
      }
      mensaje=mensaje+"\n ✓"+this.cierre_caja.partidos[i].equipo_2.nombre;
      for(let j=0;j<this.cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
        if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("ARBITRAJE")){
          mensaje=mensaje+"\n    👨🏽‍⚖️ "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("AMARILLA")){
          mensaje=mensaje+"\n    🟨 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("ROJA")){
          mensaje=mensaje+"\n    🟥 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN BALON")){
          mensaje=mensaje+"\n    ⚽ "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("SIN CINTILLO")){
          mensaje=mensaje+"\n    🎗️ "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else if(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre.toUpperCase().includes("PONCHILLOS")){
          mensaje=mensaje+"\n    🎽 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre;
        }else{
          mensaje=mensaje+"\n    💵 "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].producto.nombre+(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion?" "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].descripcion:"");
        }
        mensaje=mensaje+(this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].fecha?" - "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].fecha:"")+"\n";
        mensaje=mensaje+"      💵 Bs "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].importe;
        mensaje=mensaje+" | 🏁 Bs "+this.cierre_caja.partidos[i].equipo_2.detalle_pago[j].qr;
      }
    }

    mensaje=mensaje+"\n\n📈 Ingresos: \n 💵 Efectivo Bs "+this.cierre_caja.total_ingresos_efectivo+"\n 🏁 Ingresos QR: Bs "+this.cierre_caja.total_ingresos_qr+"\n\n";
    mensaje=mensaje+"📉 Egresos: \n 🧑🏽‍⚖️ Pago Arbitro Bs "+this.cierre_caja.pago_arbitro+"\n 🧑🏽‍⚖️ Pago Mesa: Bs "+this.cierre_caja.pago_mesa+"\n  💵  Pago Otros: Bs "+this.cierre_caja.pago_otros+"\n\n";
    mensaje=mensaje+"💸 Saldo Faltante: Bs "+this.cierre_caja.saldo_faltante+"\n💸 Saldo Sobrante: Bs "+this.cierre_caja.saldo_sobrante+"\n\n";
    mensaje=mensaje+"💵 *Saldo Final: Bs "+this.cierre_caja.saldo_caja+"*";

    navigator.clipboard.writeText(mensaje);
  }

  establecerWOEquipo1(partido){
    if(partido.w_o_equipo_1.es_wo){
      let producto_w_o=this.productos.filter(p => p.nombre.includes("MULTA W.O."))[0];
      partido.equipo_2.detalle_pago[0].producto=producto_w_o;
      partido.equipo_2.detalle_pago[0].descripcion="Partido contra "+partido.equipo_1.nombre;
      partido.equipo_2.detalle_pago[0].precio_unitario=producto_w_o.precio_unitario;
      partido.equipo_2.detalle_pago[0].importe=0;
      partido.equipo_2.detalle_pago[0].total=producto_w_o.precio_unitario;
      partido.equipo_2.detalle_pago[0].qr=0;
      partido.equipo_1.detalle_pago[0].precio_unitario=partido.equipo_1.detalle_pago[0].total*2;
      partido.equipo_1.detalle_pago[0].importe=partido.equipo_1.detalle_pago[0].total*2;
      partido.equipo_1.detalle_pago[0].total=partido.equipo_1.detalle_pago[0].total*2;
      partido.w_o_equipo_2.es_wo=!partido.w_o_equipo_1.es_wo;
      if(partido.disciplina.nombre=="BALONCESTO"){
        partido.marcador_equipo_1=20;
        partido.marcador_equipo_2=0;
      }else{
        partido.marcador_equipo_1=3;
        partido.marcador_equipo_2=0;
      }
    }else{
      partido.equipo_2.detalle_pago[0].producto=this.rol_partido.campeonato.derecho_cancha;
      partido.equipo_2.detalle_pago[0].descripcion="";
      partido.equipo_2.detalle_pago[0].precio_unitario=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_2.detalle_pago[0].importe=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_2.detalle_pago[0].total=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_2.detalle_pago[0].qr=0;
      partido.equipo_1.detalle_pago[0].precio_unitario=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_1.detalle_pago[0].importe=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_1.detalle_pago[0].total=this.cierre_caja.importe_derecho_cancha;
    }
  }

  establecerWOEquipo2(partido){
    if(partido.w_o_equipo_2.es_wo){
      let producto_w_o=this.productos.filter(p => p.nombre.includes("MULTA W.O."))[0];
      partido.equipo_1.detalle_pago[0].producto=producto_w_o;
      partido.equipo_1.detalle_pago[0].descripcion="Partido contra "+partido.equipo_2.nombre;
      partido.equipo_1.detalle_pago[0].precio_unitario=producto_w_o.precio_unitario;
      partido.equipo_1.detalle_pago[0].importe=0;
      partido.equipo_1.detalle_pago[0].total=producto_w_o.precio_unitario;
      partido.equipo_1.detalle_pago[0].qr=0;
      partido.equipo_2.detalle_pago[0].precio_unitario=partido.equipo_2.detalle_pago[0].total*2;
      partido.equipo_2.detalle_pago[0].importe=partido.equipo_2.detalle_pago[0].total*2;
      partido.equipo_2.detalle_pago[0].total=partido.equipo_2.detalle_pago[0].total*2;
      partido.w_o_equipo_1.es_wo=!partido.w_o_equipo_2.es_wo;
      if(partido.disciplina.nombre=="BALONCESTO"){
        partido.marcador_equipo_1=0;
        partido.marcador_equipo_2=20;
      }else{
        partido.marcador_equipo_1=0;
        partido.marcador_equipo_2=3;
      }
    }else{
      partido.equipo_1.detalle_pago[0].producto=this.rol_partido.campeonato.derecho_cancha;
      partido.equipo_1.detalle_pago[0].descripcion="";
      partido.equipo_1.detalle_pago[0].precio_unitario=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_1.detalle_pago[0].importe=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_1.detalle_pago[0].total=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_1.detalle_pago[0].qr=0;
      partido.equipo_2.detalle_pago[0].precio_unitario=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_2.detalle_pago[0].importe=this.cierre_caja.importe_derecho_cancha;
      partido.equipo_2.detalle_pago[0].total=this.cierre_caja.importe_derecho_cancha;
    }
  }

  async crearNuevoJugador(equipo){
      this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
      this.modalJugador.componentInstance.equipo = equipo;
      this.modalJugador.componentInstance.usuario = this.usuario;
      
      this.modalJugador.componentInstance.alTerminar.subscribe(async (res) => {
        if(res){
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
            this.toastr.error(res.stack.substring(0,500));
          }else{
            this.modalJugador.close();
            this.blockUI.start();
            let jugadores:any=await this.campeonatosService.obtenerListaJugadores(this.usuario.id_empresa,equipo.id).toPromise();
            this.blockUI.stop();
            equipo.jugadores=jugadores;
          }
        }else{
          this.modalJugador.close();
        }
        
      });
    }

  async askGemini(image) {console.log(image);
        image.inlineData.data=image.inlineData.data.split(',')[1];
        if (true) {
          try {
            //let geminiResponse = await this.geminiService.generateContent("ejemplo codigo angular para leer imagen y convertir json con gemini");
            //let geminiResponse = await this.geminiService.generateContent("Describe the image. Extract key information and represent it as a JSON object. Extract data as a product list. Focus on identifying objects, their attributes, and relationships between them. The output should be a valid JSON format. Include details like color, size, location, and any notable characteristics of the identified objects.", image);
            let geminiResponse = await this.geminiService.leerPlanillaPartido("Convertir a JSON la planilla de partido, extrayendo datos, equipos, jugadores, sus codigos, goles, total goles, tarjetas amarillas y tarjetas rojas de cada jugador.", image);
            //let geminiResponse = await this.geminiService.generateContent("can you summarize what is in the image and return the answer with json format", image);
            console.log(JSON.parse(geminiResponse));
            //this.procesarDatosFactura(JSON.parse(geminiResponse));
          } catch (error) {
            console.log(error);
          }
        }
  }

    subirArchivoGemini(file){
      let me=this;console.log(file);
      var fileToLoad = file.target.files[0];
        var fileReader = new FileReader();
  
        fileReader.onloadend = async function() 
        {
          let base64EncodedImage = fileReader.result; // <--- data: base64
          me.askGemini({
            inlineData: { data: await base64EncodedImage, mimeType: file.target.files[0].type },
         });
        }
        fileReader.readAsDataURL(fileToLoad);	
    }

    public triggerSnapshot(): void {
        this.trigger.next();
    }
  
    public get triggerObservable(): Observable<void> {
      return this.trigger.asObservable();
    }
  
    public handleImage(webcamImage: WebcamImage): void {
      this.webcamImage = webcamImage;
      const dataUrl = webcamImage.imageAsDataUrl;
      //this.jugador.persona.imagen=dataUrl;
      //this.imageChangedEvent = { target: { result: webcamImage.imageAsDataUrl } };
      this.askGemini({
        inlineData: { data: dataUrl, mimeType: dataUrl.split(';')[0].split(':')[1]},
      });
    }
  
    public capturarImagen(): void {
      this.usando_camara=true;
      this.trigger.next();
    }

    subirArchivoFotoPlanilla(file){
      let me=this;
      this.usando_camara=false;
      var fileToLoad = file.target.files[0];
        var fileReader = new FileReader();

        fileReader.onloadend = function() 
        {
          let base64EncodedImage = fileReader.result; // <--- data: base64
          //me.jugador.persona.imagen=base64EncodedImage;
          //me.fileChangeEvent(file);
          me.askGemini({
            inlineData: { data: base64EncodedImage, mimeType: file.target.files[0].type },
          });
        }
        fileReader.readAsDataURL(fileToLoad);	
        this.clearInput();
    }

  clearInput(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Resets the file input
      console.log('Input cleared');
    }
  }

  sumarMarcadorEquipo(equipo){
    equipo.total_marcador=0;
    for(let i=0;i<equipo.jugadores.length;i++){
      equipo.total_marcador=equipo.total_marcador+(equipo.jugadores[i].jugador.marcador==undefined?0:equipo.jugadores[i].jugador.marcador);
    }
    return equipo.total_marcador;
  }
}
